"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sighting = exports.DAMAGE_TYPES = exports.ACTIVITY_TYPES = exports.SIGHTING_TYPES = exports.SIGHTINGS_MODULE = void 0;
exports.sightingTypeIconName = sightingTypeIconName;
exports.sightingSpeciesSummary = sightingSpeciesSummary;
const utils_1 = require("../utils");
exports.SIGHTINGS_MODULE = 'sightings';
exports.SIGHTING_TYPES = [
    { value: 'wildSighting', labelKey: 'COCKPIT.SIGHTINGS.type.wildSighting', iconName: 'wildlife-sighting' },
    { value: 'wildActivity', labelKey: 'COCKPIT.SIGHTINGS.type.wildActivity', iconName: 'wildlife-activity' },
    { value: 'damage', labelKey: 'COCKPIT.SIGHTINGS.type.damage', iconName: 'damage-anomaly' },
];
exports.ACTIVITY_TYPES = [
    { value: 'rubbingTree', labelKey: 'COCKPIT.SIGHTINGS.activityType.rubbingTree' },
    { value: 'scrape', labelKey: 'COCKPIT.SIGHTINGS.activityType.scrape' },
    { value: 'bedding', labelKey: 'COCKPIT.SIGHTINGS.activityType.bedding' },
    { value: 'burrow', labelKey: 'COCKPIT.SIGHTINGS.activityType.burrow' },
    { value: 'feedingSite', labelKey: 'COCKPIT.SIGHTINGS.activityType.feedingSite' },
    { value: 'diggingSite', labelKey: 'COCKPIT.SIGHTINGS.activityType.diggingSite' },
    { value: 'dropping', labelKey: 'COCKPIT.SIGHTINGS.activityType.dropping' },
    { value: 'footprint', labelKey: 'COCKPIT.SIGHTINGS.activityType.footprint' },
    { value: 'wildlifeTrail', labelKey: 'COCKPIT.SIGHTINGS.activityType.wildlifeTrail' },
    { value: 'other', labelKey: 'COCKPIT.SIGHTINGS.activityType.other' },
];
exports.DAMAGE_TYPES = [
    { value: 'browsing', labelKey: 'COCKPIT.SIGHTINGS.damageType.browsing' },
    { value: 'barkStripping', labelKey: 'COCKPIT.SIGHTINGS.damageType.barkStripping' },
    { value: 'crop', labelKey: 'COCKPIT.SIGHTINGS.damageType.crop' },
    { value: 'diggingDamage', labelKey: 'COCKPIT.SIGHTINGS.damageType.diggingDamage' },
    { value: 'injuredAnimal', labelKey: 'COCKPIT.SIGHTINGS.damageType.injuredAnimal' },
    { value: 'sickAnimal', labelKey: 'COCKPIT.SIGHTINGS.damageType.sickAnimal' },
    { value: 'other', labelKey: 'COCKPIT.SIGHTINGS.damageType.other' },
];
class Sighting {
    constructor() {
        this.className = "Sighting";
        this.contextIds = undefined;
        this.contextIdRights = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.sightingType = undefined;
        this.location = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        /** (Suspected) species observed — all three sighting types use this. */
        this.species = undefined;
        /** wildSighting only. */
        this.behaviour = undefined;
        /** wildActivity only — one of ACTIVITY_TYPES. */
        this.activityType = undefined;
        /** damage only — one of DAMAGE_TYPES. */
        this.damageType = undefined;
        /** All types — free text (health condition / freshness / severity, depending on type). */
        this.condition = undefined;
        this.note = undefined;
        this.userId = undefined;
        this.userDisplayName = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
    }
    setFromAny(element) {
        const { identifier, contextIdRights, contextIds, contextId, sightingType, location, huntingDistrictId, huntingDistrictName, species, behaviour, activityType, damageType, condition, note, userId, userDisplayName, creationDate, updateTimestamp } = element;
        this.contextIds = contextIds ? contextIds : this.contextIds;
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.sightingType = sightingType ? sightingType : this.sightingType;
        this.location = location ? location : this.location;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
        this.species = species ? species : this.species;
        this.behaviour = behaviour ? behaviour : this.behaviour;
        this.activityType = activityType ? activityType : this.activityType;
        this.damageType = damageType ? damageType : this.damageType;
        this.condition = condition ? condition : this.condition;
        this.note = note ? note : this.note;
        this.userId = userId ? userId : this.userId;
        this.userDisplayName = userDisplayName ? userDisplayName : this.userDisplayName;
        this.creationDate = creationDate ? creationDate : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, utils_1.isDate)(updateTimestamp) ? updateTimestamp : (0, utils_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
    }
    searchFilter(filter) {
        const str = `${this.note}${this.huntingDistrictName}${this.identifier}${this.behaviour}${this.location}${this.condition}`.toLowerCase();
        return str.includes(filter);
    }
    /**
       * Function for skipping objects and data while deepcopying class.
       * used as optional Input for deepCopy(any, replacerFn)
       * @param key
       */
    replacerFn(key) {
        if (key == "className")
            return false;
        else
            return true;
    }
}
exports.Sighting = Sighting;
Sighting.className = "Sighting";
function sightingTypeIconName(type) {
    var _a, _b;
    return (_b = (_a = exports.SIGHTING_TYPES.find(t => t.value === type)) === null || _a === void 0 ? void 0 : _a.iconName) !== null && _b !== void 0 ? _b : 'pin';
}
/** `species.species` stores a species identifier (same convention as GameRecord's
 * `wildart`) — pass a lookup to resolve it to a display name, e.g. built from
 * `context.settingsMap.get(SETTING_SPECIES).values`. */
function sightingSpeciesSummary(species, nameById) {
    return (species !== null && species !== void 0 ? species : [])
        .map(s => { var _a, _b; return `${(_a = s.count) !== null && _a !== void 0 ? _a : 1} ${(_b = nameById === null || nameById === void 0 ? void 0 : nameById.get(s.species)) !== null && _b !== void 0 ? _b : s.species}`; })
        .join(', ');
}
